const BASE_URL = '/'
const AUTH = BASE_URL
const HOME = `${BASE_URL}home`
const ADMIN = `${BASE_URL}admin`
const ADMIN_ORCAMENTOS = `${ADMIN}/orcamentos`
const ADMIN_SINCRONIZACOES = `${ADMIN}/sincronizacoes`
const ADMIN_CC_BLOQUEADOS = `${ADMIN}/centros-custos-bloqueados`
const ADMIN_USUARIOS_PERMISSAO = `${ADMIN}/usuarios-permissao`
const ADMIN_IMPORTACAO = `${ADMIN}/importacao`
const CC_DETALHES = `${BASE_URL}centro-de-custo/:codCCustoPai`
const PREENCHIMENTO = `${BASE_URL}preenchimento`
const METAS = `${BASE_URL}metas`
const RELATORIOS = `${BASE_URL}relatorios`
const RELATORIO_CONFERIR_PREENCHIMENTO = `${RELATORIOS}/conferir-preenchimento`
const RELATORIO_TRIMESTRAL = `${RELATORIOS}/trimestral`
const RELATORIO_TRIMESTRAL_POR_REGIONAL = `${RELATORIOS}/trimestral-por-regional`
const RELATORIO_RECEITA = `${RELATORIOS}/receita`
const RELATORIO_EXPORTACAO = `${RELATORIOS}/exportacao`
const RELATORIO_ORCAMENTARIO = `${RELATORIOS}/orcamentario`
const RELATORIO_ORCAMENTARIO_TRIMESTRAL = `${RELATORIOS}/orcamentario-trimestral`
const RELATORIO_ORCAMENTARIO_COMPARATIVO = `${RELATORIOS}/orcamentario-comparativo`
const RELATORIO_ORCAMENTARIO_COMPARATIVO_ANO = `${RELATORIOS}/orcamentario-comparativo-ano`
const RELATORIO_MEMORIA_CALCULO = `${RELATORIOS}/memoria-calculo`
const RELATORIO_ORCAMENTO_TEMPO_REAL = `${RELATORIOS}/orcamento-tempo-real`
const RELATORIO_TOTAIS_CENTRO_CUSTO = `${RELATORIOS}/totais-centro-custo`
const RELATORIO_IMPORTACAO_SISTEGO = `${RELATORIOS}/importacao-sistego`
const EMBEDS = `${BASE_URL}embeds`
const EMBEDS_PORWER_BI = `${EMBEDS}/power-bi`
const UNAUTHORIZED = `${BASE_URL}not-authorized`

export default {
  BASE_URL,
  AUTH,
  HOME,
  ADMIN,
  ADMIN_ORCAMENTOS,
  ADMIN_SINCRONIZACOES,
  ADMIN_CC_BLOQUEADOS,
  ADMIN_USUARIOS_PERMISSAO,
  ADMIN_IMPORTACAO,
  CC_DETALHES,
  PREENCHIMENTO,
  METAS,
  RELATORIOS,
  RELATORIO_CONFERIR_PREENCHIMENTO,
  RELATORIO_TRIMESTRAL,
  RELATORIO_TRIMESTRAL_POR_REGIONAL,
  RELATORIO_RECEITA,
  RELATORIO_EXPORTACAO,
  RELATORIO_ORCAMENTARIO,
  RELATORIO_ORCAMENTARIO_TRIMESTRAL,
  RELATORIO_ORCAMENTARIO_COMPARATIVO,
  RELATORIO_ORCAMENTARIO_COMPARATIVO_ANO,
  RELATORIO_MEMORIA_CALCULO,
  RELATORIO_ORCAMENTO_TEMPO_REAL,
  RELATORIO_TOTAIS_CENTRO_CUSTO,
  RELATORIO_IMPORTACAO_SISTEGO,
  EMBEDS,
  EMBEDS_PORWER_BI,
  UNAUTHORIZED,
}
